module.exports = __webpack_public_path__ + "static/136212765-5f8d0f19a768a822be8dd15ff1051d1e.jpg";